module.exports = __webpack_public_path__ + "static/pause-button-19b7fa5c418b78d935e409113feaf632.png";